<template>
  <div>
    <component
      :is="customRelatedContent.component"
      v-if="!!customRelatedContent"
      :blok="customRelatedContent"
    />
    <div v-else>
      <ClientOnly>
        <BlockRelatedCards
          :blok="blok"
          :filtered-audiences="filteredAudiences"
          :filtered-topics="filteredTopics"
        />
      </ClientOnly>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RelatedContent } from './BlockRelatedCards.vue'

const props = withDefaults(
  defineProps<{
    blok: RelatedContent
    relatedContentTypes?: string[]
  }>(),
  {
    relatedContentTypes: () => [
      'resources',
      'news',
      'events',
      'featured-articles',
      'featured-topics',
      'audiences',
      'real-stories',
    ],
  },
)
const { customRelatedContent } = useStoryContent(toRefs(props))
const viewedTopicsStore = useViewedTopicsStore()
const { viewedTopics } = storeToRefs(viewedTopicsStore)
const viewedAudiencesStore = useViewedAudiencesStore()
const { viewedAudiences } = storeToRefs(viewedAudiencesStore)
const numTopics = 5
const numAudiences = 5

const currentPageTopics = computed(() => props.blok?.topics || [])
const currentPageAudiences = computed(() => props.blok?.audiences || [])
const mostViewedTopics = computed(() => {
  const terms = viewedTopics.value
  const keys = [...Object.keys(terms)]
  const sorted = keys.sort(function (a, b) {
    return terms[b] - terms[a]
  })
  return sorted.slice(0, numTopics)
})
const mostViewedAudiences = computed(() => {
  const terms = viewedAudiences.value
  const keys = [...Object.keys(terms)]
  const sorted = keys.sort(function (a, b) {
    return terms[b] - terms[a]
  })

  // remove the relatively useless "all" audience that permeates most content
  return sorted.filter((item) => item !== 'all').slice(0, numAudiences)
})
const filteredTopics = computed(
  () =>
    [
      ...new Set([...mostViewedTopics.value, ...currentPageTopics.value]),
    ] as string[],
)
const filteredAudiences = computed(
  () =>
    [
      ...new Set([...mostViewedAudiences.value, ...currentPageAudiences.value]),
    ] as string[],
)
</script>
